import { getOmnitureDataObj } from './services';
import globalVars from './global-vars';

declare global {
    interface Window {
        s_omni: any;
        externalWindowLink: any;
    }
}

const getOmnitureData = (pageOmniData) => {
    const { isOmnitureDisable } = globalVars;
    return {
        omniAllPagesData: pageOmniData,
        omniPageViewData: function (pageUrl) {
            if (typeof window.s_omni === 'undefined' || isOmnitureDisable) return;
            if (pageOmniData.hasOwnProperty(pageUrl)) {
                return pageOmniData[pageUrl];
            }
        },
        omniLinkClick: function (omniObject, linkType, omniLinkName, prop15, prop16) {
            if (typeof window.s_omni === 'undefined' || isOmnitureDisable) return;
            const source = getCookie('auth-src');
            if (source === 'wire') {
                omniLinkName = 'WSL:' + getCookie('store-no') + ' ' + omniLinkName;
            }
            if (typeof window.externalWindowLink != 'undefined') window.externalWindowLink = 'false';
            const s_linkTrackVarsTemp = window.s_omni.linkTrackVars;
            const s_linkTrackEventsTemp = window.s_omni.linkTrackEvents;
            window.s_omni.linkTrackVars = 'prop54,prop15,prop16';
            window.s_omni.linkTrackEvents = 'None';
            if (prop16) {
                window.s_omni.prop16 = prop16;
            }
            if (prop15) {
                window.s_omni.prop15 = prop15;
            }
            window.s_omni.prop54 = window.s_omni.prop2 + ' | ' + omniLinkName;
            window.s_omni.tl(omniObject, linkType, omniLinkName);
            window.s_omni.linkTrackVars = s_linkTrackVarsTemp;
            window.s_omni.linkTrackEvents = s_linkTrackEventsTemp;
            window.s_omni.prop54 = '';
            window.s_omni.prop16 = '';
            window.s_omni.prop15 = '';
        },
        xhr: function (omniObject, linkType, omniLinkName, prop15, prop16) {
            if (typeof window.s_omni === 'undefined' || isOmnitureDisable) return;
            if (!window.s_omni.pageName) {
                if (findPageName(pageOmniData) == false) {
                    return;
                }
            }
            const source = getCookie('auth-src');
            if (source === 'wire') {
                omniLinkName = 'WSL:' + getCookie('store-no') + ' ' + omniLinkName;
            }
            if (typeof window.externalWindowLink != 'undefined') window.externalWindowLink = 'false';
            const s_linkTrackVarsTemp = window.s_omni.linkTrackVars;
            const s_linkTrackEventsTemp = window.s_omni.linkTrackEvents;
            window.s_omni.linkTrackVars = 'prop54,prop15,prop16';
            window.s_omni.linkTrackEvents = 'None';
            if (prop16) {
                window.s_omni.prop16 = prop16;
            }
            if (prop15) {
                window.s_omni.prop15 = prop15;
            }
            window.s_omni.prop54 = window.s_omni.pageName + ' | ' + omniLinkName;
            window.s_omni.pageName = 'Aura-' + window.s_omni.pageName;
            window.s_omni.tl(omniObject, linkType, omniLinkName);
            window.s_omni.linkTrackVars = s_linkTrackVarsTemp;
            window.s_omni.linkTrackEvents = s_linkTrackEventsTemp;
            window.s_omni.prop54 = '';
            window.s_omni.prop16 = '';
            window.s_omni.prop15 = '';
            window.s_omni.pageName = window.s_omni.pageName.slice(5);
        },
        error: function (omniObject, linkType, omniLinkName, prop15, prop48) {
            if (typeof window.s_omni === 'undefined' || isOmnitureDisable) return;
            if (!window.s_omni.pageName) {
                if (findPageName(pageOmniData) == false) {
                    return;
                }
            }
            if (typeof window.externalWindowLink != 'undefined') window.externalWindowLink = 'false';
            const s_linkTrackVarsTemp = window.s_omni.linkTrackVars;
            const s_linkTrackEventsTemp = window.s_omni.linkTrackEvents;
            window.s_omni.linkTrackVars = 'prop54,prop15,prop48';
            window.s_omni.linkTrackEvents = 'None';
            if (prop48) {
                window.s_omni.prop48 = prop48;
            }
            if (prop15) {
                window.s_omni.prop15 = prop15;
            }
            window.s_omni.prop54 = window.s_omni.pageName + ' | ' + omniLinkName;
            window.s_omni.pageName = 'Aura-' + window.s_omni.pageName;
            window.s_omni.tl(omniObject, linkType, omniLinkName);
            window.s_omni.linkTrackVars = s_linkTrackVarsTemp;
            window.s_omni.linkTrackEvents = s_linkTrackEventsTemp;
            window.s_omni.prop54 = '';
            window.s_omni.prop48 = '';
            window.s_omni.prop15 = '';
            window.s_omni.pageName = window.s_omni.pageName.slice(5);
        },
        omniPageSearch: function (pageName, prop1, prop2, prop14, prop15, prop23) {
            if (typeof window.s_omni === 'undefined' || isOmnitureDisable) return;
            const omni = {
                adid: window.s_omni.getQueryParam('adid'),
                fbref: window.s_omni.getQueryParam('fb_ref'),
                sourceid: window.s_omni.getQueryParam('sourceid'),
                povid: window.s_omni.getQueryParam('povid'),
                findingMethod: window.s_omni.getQueryParam('findingMethod'),
                getCampaignId: function () {
                    if (this.adid) {
                        return this.adid;
                    } else if (this.fbref) {
                        return this.fbref.split('_')[1];
                    } else if (this.sourceid) {
                        return this.sourceid;
                    } else {
                        return '';
                    }
                },
            };
            window.s_omni.pageName = pageName; //Page Title
            window.s_omni.channel = document.location.hostname; //Channel – Set to the domain
            window.s_omni.campaign = omni.getCampaignId();
            window.s_omni.prop1 = prop1; //Page Type
            window.s_omni.prop2 = prop2; //same as pagename
            window.s_omni.prop14 = prop14; //Search Term used
            window.s_omni.prop15 = prop15; //User Type
            window.s_omni.prop23 = prop23; //Search by
            const s_code = window.s_omni.t();
            if (s_code) {
                document.write(s_code);
            }
        },
        omnitureBasicMetrics: function (pageName, prop1, prop2, prop14, prop15) {
            if (typeof window.s_omni === 'undefined' || isOmnitureDisable) return;
            const source = getCookie('auth-src');
            if (source === 'wire') {
                prop14 = 'WSL:' + getCookie('store-no') + ' ' + prop15;
            }
            const omni = {
                adid: window.s_omni.getQueryParam('adid'),
                fbref: window.s_omni.getQueryParam('fb_ref'),
                sourceid: window.s_omni.getQueryParam('sourceid'),
                povid: window.s_omni.getQueryParam('povid'),
                findingMethod: window.s_omni.getQueryParam('findingMethod'),
                getCampaignId: function () {
                    if (this.adid) {
                        return this.adid;
                    } else if (this.fbref) {
                        return this.fbref.split('_')[1];
                    } else if (this.sourceid) {
                        return this.sourceid;
                    } else {
                        return '';
                    }
                },
            };
            window.s_omni.pageName = 'Aura-' + pageName; //Page Title
            window.s_omni.channel = document.location.hostname; //Channel – Set to the domain
            window.s_omni.campaign = omni.getCampaignId();
            window.s_omni.prop1 = prop1; //Page Type
            window.s_omni.prop2 = prop2; //same as pagename
            window.s_omni.prop14 = prop14; //Search Term used
            window.s_omni.prop15 = prop15; //User Type
            const s_code = window.s_omni.t();
            if (s_code) {
                document.write(s_code);
            }
            window.s_omni.pageName = window.s_omni.pageName.slice(5);
        },
    };
};

const findPageName = (pageOmniData) => {
    if (typeof window.s_omni === 'undefined') return false;
    const pageUrl = window.location.pathname;
    if (pageOmniData.hasOwnProperty(pageUrl)) {
        window.s_omni.pageName = pageOmniData[pageUrl].pageName;
        return true;
    }
    return false;
};

const stampXHR = (config, omnitureData, userInfo, xhrResponse) => {
    if (config.url.startsWith('/api')) {
        const matchPatternWithoutParams = (link, fromRecurse) => {
            if (fromRecurse) {
                return false;
            }
            link = link.split('?')[0];
            return mapRequestName(link, true);
        };
        const mapRequestName = (link, fromRecurse?) => {
            const foundWithoutParams = matchPatternWithoutParams(link, fromRecurse);
            if (foundWithoutParams) {
                return foundWithoutParams;
            }
            return link;
        };
        const linkName = `${xhrResponse ? 'Response' : 'Request'}: ${mapRequestName(config.url)}`;
        const props = [userInfo.loggedInUserName];
        if (xhrResponse) {
            props.push(xhrResponse.status);
        }
        omnitureData.xhr(window, 'XHR', linkName, ...props);
    }
};

const getCookie = (cname) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

let omniJsonPromise = null;
let handleRequestArray = [];
const handleOmniture = (userInfo, omnitureParam, request, xhrResponse?) => {
    if (
        request.url.indexOf('api/gateway/provider-common/page?pageName=omniture') > -1 ||
        request.url.indexOf('omniturePageData.json') > -1
    )
        return request;

    if (omnitureParam.omnitureData && omnitureParam.omnitureData.length != 0) {
        // Omniture stamp xhr call
        stampXHR(xhrResponse ? xhrResponse.config : request, omnitureParam.omnitureData[0], userInfo, xhrResponse);
        return request;
    }

    handleRequestArray.push({ req: request, xhrResponse });

    if (!omniJsonPromise) {
        omniJsonPromise = getOmnitureDataObj();
        return omniJsonPromise
            .then((response) => {
                omniJsonPromise = null;
                //Check if response format is correct. Else return
                if (response.data && typeof response.data == 'object') {
                    response = getOmnitureData(response.data);
                    omnitureParam.omnitureData.push(response);
                    omnitureParam.setOmnitureData(response);
                    // Omniture stamp xhr call
                    handleRequestArray.forEach(({ req, xhrResponse }) => {
                        stampXHR(xhrResponse ? xhrResponse.config : req, response, userInfo, xhrResponse);
                    });
                    handleRequestArray = [];
                }
                return Promise.resolve(request);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    return request;
};

export { getOmnitureData, stampXHR, handleOmniture };
